import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import myGlobals = require('../config');

@Injectable()
export class HusoHorarioService {

    private husoHorarioURL = myGlobals.default.BASE_URL + '/husoHorario/';  // URL to web api

    constructor(private http: Http) {
    }

    //Obtener todas las husos horarios
    getHusosHorarios() {
        return this.http.get(this.husoHorarioURL)
            .map((response) => response.json());
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/husoHorario/husoHorario.service.ts